export default __webpack_public_path__ + "static/media/shipping1.d9fa9371.svg";